import { cn } from '@/utils/styles';
import { getTimeBasedGreetingAndBgImg } from '@/components/utils/Timezone';
interface HomeGreetingProps {
  userName: string;
  className?: string;
}

export const HomeGreeting = ({
  userName,
  className,
}: HomeGreetingProps) => {
  return (
    <div className={className}>
      <span 
        className={cn(
          "block font-serif typography-body italic",
         
        )}
      >
        {getTimeBasedGreetingAndBgImg().greeting}
      </span>
      <h1 
        className={cn(
          "typography-d1",
       
        )}
      >
        {userName}
      </h1>
    </div>
  );
};